export default "__VITE_ASSET__CwztxEAe__"